var openLightBox = function (imageDom, videoDom) {
    //Image LightBox
    $(imageDom).magnificPopup({
        type: 'image',
        gallery: {
            enabled: !0
        },
        mainClass: 'mfp-with-zoom',
        zoom: {
            enabled: true,
            duration: 300,
            easing: "ease-in-out",
            opener: function(a) {
                return a.is("img") ? a : a.find("img")
            }
        }
    });

    //Video LightBox
    $(videoDom).magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        iframe: {
            markup: '<div class="mfp-iframe-scaler">'+
                '<div class="mfp-close"></div>'+
                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                '</div>',
            srcAction: 'iframe_src'
        }
    });
};

jQuery(document).ready(function($){
    openLightBox('.image-lightbox-gallery', '.video-lightbox-gallery');
});